import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { PaginatedResponse, PaginationInfo } from 'src/app/shared/models';
import { SubscribersService } from 'src/app/services/subscribers/subscribers.service';

@Component({
  selector: 'app-subscribers-listing',
  templateUrl: './subscribers-listing.component.html',
  styleUrls: ['./subscribers-listing.component.scss']
})
export class SubscribersListingComponent extends DestructorComponent implements OnInit {

  // Data properties
  subscribers: any[] = [];
  isLoading = false;

  // Pagination
  currentPage = 1;
  paginationInfo: PaginationInfo = {
    currentPage: 1,
    perPage: 20,
    total: 0,
    lastPage: 1,
    firstPage: 1
  };

  // Search
  searchTerm = '';

  constructor(
    private _subscribersService: SubscribersService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadSubscribers();
  }

  loadSubscribers(page: number = 1, search: string = ''): void {
    this.isLoading = true;
    this.currentPage = page;
    this.searchTerm = search;

    this.subscriptions.push(
      this._subscribersService.GetData(page.toString(), search, {is_subscribed: true}).subscribe({
        next: (response: PaginatedResponse<any>) => {
          if (response.status && response.data) {
            this.subscribers = response.data.data || [];
            this.paginationInfo = response.data.pagination;
            this.currentPage = response.data.pagination.currentPage;
          } else {
            this.subscribers = [];
            this.resetPagination();
          }
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error loading subscribers:', error);
          this.subscribers = [];
          this.resetPagination();
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      })
    );
  }

  onPageChange(page: number): void {
    this.loadSubscribers(page, this.searchTerm);
  }

  onSearch(): void {
    this.loadSubscribers(1, this.searchTerm);
  }

  private resetPagination(): void {
    this.paginationInfo = {
      currentPage: 1,
      perPage: 20,
      total: 0,
      lastPage: 1,
      firstPage: 1
    };
  }

  trackByFn(index: number, item: any): any {
    return item._id || index;
  }
}
